import { render } from "./SignScreen.vue?vue&type=template&id=57f539a2"
import script from "./SignScreen.js?vue&type=script&lang=js"
export * from "./SignScreen.js?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__